module.exports = __webpack_public_path__ + "static/img/icon_ins@2x.ecf42a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/icon_ins@2x.png
// module id = gYw+
// module chunks = 0